import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';
import { RouterModule } from '@angular/router';

@Component({
  templateUrl: './basiq-consent.page.html',
  styleUrls: ['./basiq-consent.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    FlexModule,
    RouterModule
  ]
})
export class BasiqConsentPage {
  constructor() {}

  ngAfterViewInit() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
}